<div [class]="props.labelClassName" [class.required]="props.required">
  {{ props.label }}
</div>
